<template>
  <div class="report-contaier">
    <div>
      <report-order-status></report-order-status>
    </div>
    <div>
      <report-order></report-order>
    </div>
    <div>
      <report-order-amount></report-order-amount>
    </div>
  </div>
</template>

<script>
import ReportOrderByTime from "./ReportOrderByTime";
import ReportOrderAmountByTime from "./ReportOrderAmountByTime";
import ReportOrderStatusByTime from "./ReportOrderStatusByTime";

export default {
  components: {
    "report-order": ReportOrderByTime,
    "report-order-status": ReportOrderStatusByTime,
    'report-order-amount': ReportOrderAmountByTime
  }
};
</script>

<style lang="scss" scoped>
  .report-contaier {
    position: relative;
    overflow: hidden;
  }
</style>
